module.exports = __webpack_public_path__ + "static/media/MT.706a56e7.webp";